<div class="lang-icon" (click)="cultureOpen = !cultureOpen"></div>


<div class="thermoeyes-culture-wrapper" [class.show]="cultureOpen">
  <div *ngFor="let culture of authService.cultures | filter:['isActive', true]" class="culture-item" (click)="setCulture(culture);" [ngClass]="{'active': authService.isCultureActive(culture)}">
    <img [src]="getFlagIcon(culture) | cdn" alt="">
    <span [innerHtml]="culture.name"></span>
  </div>
</div>